module.exports = __webpack_public_path__ + "img/t2-5.6d3974c0.svg";